'use strict';

export default class{
	/*@ngInject*/
	constructor($http, $scope, tutorID){
		this.$http = $http;
		this.$scope = $scope;
		this.loaded = true;
		this.student = {
			nameFirst: '',
			nameLast: '',
			state: '',
			crmID: '',
			tuteLocation: '',
		};

		this.preset = false;
		this.presetNew = true;
		this.tutorID = tutorID;
		this.students = [];
		this.locations = [{
				fullname: 'Cannon Hill',
				value: 'C'
			},{
				fullname: 'Home',
				value: 'H',
			}, {
				fullname: 'Online',
				value: 'O',
			}, {
				fullname: 'Paddington',
				value: 'P',
			},{
				fullname: 'Mt Gravatt',
				value: 'M',
			}];
		this.states = ['QLD', 'NSW', 'VIC', 'SA', 'WA', 'TAS', 'NT', 'ACT'];
	}

	$onInit(){
		this.$http.get('/api/students').then(res => {
	      this.students = res.data;
	      this.students = this.students.map(student => {
	        student.fullName = student.nameFirst + ' ' + student.nameLast;
	        return student;
	      })
	    })
	}

	createPreset(studentID, callback){
		const preset = {
			tutorID: this.tutorID,
			studentID,
			hours: 1,
			rateType: 'B',
		};

		this.$http.post('/api/presets', preset).then(res => {
			callback(studentID)
		})
	}

	create(callback){
		var regex = /\d+-[1-9]/;
		if (regex.test(this.student.crmID) && this.student.crmID.split('-')[0].length === 5) {
			this.$http.get('/api/students/crm-id', {params: {id: this.student.crmID}}).then(res => {
				if (res.data === ""){
					this.$scope.error = null;
					this.$http.post('/api/students', this.student).then(res => {
						this.student = {};
						const studentID = res.data.studentID;
						if(this.presetNew){
							return this.createPreset(studentID, callback);
						}
						callback(studentID);
					})
				} else{
					this.$scope.error = "The CRM ID already exists. Try another one";
				}
			})
		} else {
			this.$scope.error = "Wrong format CRM ID";
		}
	}

	addExisting(callback){
		const studentID = this.selected.studentID;
		if(this.preset){
			return this.createPreset(studentID, callback)
		}
		callback(studentID);
	}
}


// WEBPACK FOOTER //
// ./client/app/modals/create-student/create-student.controller.js